import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'icon',
    label: i18n('entities.workflow.fields.icon'),
    schema: schemas.images(
      i18n('entities.workflow.fields.icon'),
      {},
    ),
  },
  {
    name: 'active',
    label: i18n('entities.workflow.fields.active'),
    schema: schemas.boolean(
      i18n('entities.workflow.fields.active'),
      {},
    ),
  },
  {
    name: 'name',
    label: i18n('entities.workflow.fields.name'),
    schema: schemas.string(
      i18n('entities.workflow.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'description',
    label: i18n('entities.workflow.fields.description'),
    schema: schemas.string(
      i18n('entities.workflow.fields.description'),
      {},
    ),
  },
  {
    name: 'flowSteps',
    label: i18n('entities.workflow.fields.flowSteps'),
    schema: schemas.relationToMany(
      i18n('entities.workflow.fields.flowSteps'),
      {},
    ),
  },
  {
    name: 'color',
    label: i18n('entities.workflow.fields.color'),
    schema: schemas.string(
      i18n('entities.workflow.fields.color'),
      {},
    ),
  },
];